<template>

    <n-drawer v-model:show="trigger" :width="330" :placement="placement" style="background-color:white;">
        <div class="Details-container">
            <b-row>
                <b-col sm="6" lg="6">
                    <p class="I-heading">User Details</p>
                </b-col>
                <b-col sm="6" lg="6">
                    <div class="closed">
                        <n-icon :size="25" @click="$emit('close')">
                            <MdClose />
                        </n-icon>
                    </div>
                </b-col>

            </b-row>

            <b-row>
                <b-col sm="6" lg="6">
                    <p class="I-heading">User Details</p>
                </b-col>
                <b-col sm="6" lg="6">
                    <div class="closed">
                        <n-icon :size="25" @click="$emit('close')">
                            <MdClose />
                        </n-icon>
                    </div>
                </b-col>

            </b-row>

            <b-row>
                <b-col sm="3">
                    <div class="profile_img">
                        <img src="../../../../../assets/Img/icons/sub-store.svg" alt="Master" />
                    </div>

                </b-col>
                <b-col sm="9">
                    <p class="user-name">Katherine Krajcik</p>
                    <p class=" user-role">Store Admin</p>
                    <p class="tablet-name">First Floor East Wing</p>

                </b-col>
            </b-row>
            <n-divider />


            <b-row>
                <div class="d-flex mt-3">
                    <img src="../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                    <h6 class="bold-heading mt6 ms-1">Member Details</h6>
                </div>
            </b-row>

            <b-row class="my-2 ps-3">
                <b-col sm="12" md="12" lg="12" xl="12">

                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">ROLE</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="sidbar-val">Store Admin</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">ASSOCIATED STORE</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="sidbar-val">First Floor East Wing</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">CREATED ON</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12" class="d-flex">
                            <p class="sidbar-val pe-3">23 Sep, 2022 </p>
                            <p class="sidbar-val">03:30 PM</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">VALID TILL</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12" class="d-flex">
                            <p class="sidbar-val pe-3">23 Sep, 2022 </p>
                            <p class="sidbar-val">03:30 PM</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">LAST LOGIN</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12" class="d-flex">
                            <p class="sidbar-val pe-3">23 Sep, 2022 </p>
                            <p class="sidbar-val">03:30 PM</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">EMAIL</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="sidbar-val">KatherineKrajcik@mocerohealth.in</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">PHONE</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="sidbar-val">+91-9884098840</p>
                        </b-col>
                    </b-row>

                    <!-- //Highlight -->
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">REPORTS TO</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="high-val">Arun Venkataraman</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="5" md="5" sm="5" cols="12">
                            <p class="sidbar-label">REPORTEES</p>
                        </b-col>
                        <b-col lg="7" md="7" sm="7" cols="12">
                            <p class="high-val">Vimalraj Ganesan, Ashok Krish, Abhijith Mazumdar, Kumar Srinivasan,
                                Ashutosh Maharana, Aparna Sundar</p>
                        </b-col>
                    </b-row>

                </b-col>
            </b-row>
            <b-row>
                <div class="d-flex mt-3 mb-4">
                    <img src="../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                    <h6 class="bold-heading mt6 ms-1">Check in & checked out asset log</h6>
                </div>
            </b-row>
            <n-card class="my-3">
                <b-row align-h="between">
                    <b-col class="d-flex px-0">
                        <p class="code">ICODE 0090</p>
                        <n-divider vertical />
                        <p class="code">PCODE 65323</p>
                        <n-divider vertical />
                        <p class="code">REQ778234</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="px-0">
                        <p class="content">2020 Apple MacBook Air Laptop: Apple M1 chip, 13.3-inch/33.74 cm Retina
                            Display,
                            8GB RAM</p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="px-0">

                        <div class="d-flex">
                            <span class="main-store">MS</span>
                            <p class="s-content">
                                First Floor East Wing
                            </p>
                            <n-icon :size="20">
                                <IosArrowRoundForward />
                            </n-icon>
                            <n-icon :size="20">
                                <IosMore />
                            </n-icon>
                            <span class="Sub-store">SS</span>
                            <p class="s-content">
                                Cardiology W345
                            </p>
                        </div>

                    </b-col>

                </b-row>
            </n-card>

            <n-card class="my-3">
                <b-row align-h="between">
                    <b-col class="d-flex px-0">
                        <p class="code">ICODE 0090</p>
                        <n-divider vertical />
                        <p class="code">PCODE 65323</p>
                        <n-divider vertical />
                        <p class="code">REQ778234</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="px-0">
                        <p class="content">2020 Apple MacBook Air Laptop: Apple M1 chip, 13.3-inch/33.74 cm Retina
                            Display,
                            8GB RAM</p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="px-0">

                        <div class="d-flex">
                            <span class="main-store">MS</span>
                            <p class="s-content">
                                First Floor East Wing
                            </p>
                            <n-icon :size="20">
                                <IosArrowRoundForward />
                            </n-icon>
                            <n-icon :size="20">
                                <IosMore />
                            </n-icon>
                            <span class="Sub-store">SS</span>
                            <p class="s-content">
                                Cardiology W345
                            </p>
                        </div>

                    </b-col>

                </b-row>
            </n-card>
            <b-row>
                <b-col class="d-flex justify-content-center py-5">
                    <button class="view-detail"><span class="pe-2"></span>View in Detail</button>
                </b-col>
            </b-row>
        </div>



    </n-drawer>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'


import { GChart } from "vue-google-charts";
export default defineComponent({
    components: {
        GChart,
    },
    props: {
        trigger: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const active = ref(true)
        const placement = ref('right')
        const data = [
            ['Element', 'Density', { role: 'style' }],
            ['Print Media', 9.95, '#dab8a7'],
            ['Social Media', 55.55, '#dab8a7'],
            ['Brodcast Media', 52.99, '#dab8a7'],
            ['Outdoor', 30.55, 'color: #dab8a7'],
            ['Internet', 45.21, 'color: #dab8a7']
        ]
        const options = {
            width: 285,
            height: 200
        }
        return {
            data,
            options,
            active,
            placement
        }
    }

})
</script>

<style lang="scss" scoped>
.user-name {
    font-size: 14px;
    font-weight: 500;
    color: #444444;
}

.user-role {
    margin-top: -5px;
    font-size: 12px;
    color: #999999;
}

.tablet-name {
    font-size: 12px;
    color: #444444;
    font-weight: 500;
}

.profile_img {
    background-color: #000000;
    border-radius: 100%;
    padding: 15px;
    margin: 2px 10px;
    width: 50px;
    height: 50px;
}

.sidbar-label {
    font-size: 13px;
    color: #999999;
}

.sidbar-val {
    font-size: 13px;
    color: #444444;
}


.Details-container {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
}

.s-content {
    font-size: 10px;

}

.main-store {
    text-align: center;
    font-size: 8px;
    border-radius: 50%;
    background-color: #CDD0FB;
    padding: 5px;
    margin-right: 10px;
    height: 21px;
    width: 22px;
}

.Sub-store {
    text-align: center;
    font-size: 8px;
    border-radius: 50%;
    background-color: #FFC3CC;
    padding: 5px;
    margin-right: 10px;
    height: 21px;
    width: 22px;
}

.dep-store {
    text-align: center;
    font-size: 10px;
    border-radius: 50%;
    background-color: #FFCCCC;
    padding: 10px;
    margin-right: 10px;
}

.code {
    font-size: 11px;
    color: #999999;
    margin-bottom: 10px;
}

.content {
    color: #000000;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 20px;
}

.high-val {
    font-size: 14px;
    color: blue;

}

.closed {

    text-align: end;
}


.I-heading {
    font-size: 15px;
    text-align: left;
    padding: 10px;
    font-weight: 600;
    color: #000000;
}

.view-detail {
    background-color: white;
    border: 1px solid #3096FF;
    color: #3096FF;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
}
</style>